<template>
  <section class="section">
    <div class="container">
      <div class="columns" v-for="(item, index) in vista" :key="index">
        <div class="column" v-if="item.tColumna1" :class="color(item.tColumna1)">
          <div v-for="(subitem, subindex) in item.columna1" :key="subindex">
            <y-subitem :subitem="subitem"></y-subitem>
          </div>
        </div>
        <div class="column" v-if="item.tColumna2" :class="color(item.tColumna2)">
          <div v-for="(subitem, subindex) in item.columna2" :key="subindex">
            <y-subitem :subitem="subitem"></y-subitem>
          </div>
        </div>
        <div class="column" v-if="item.tColumna3" :class="color(item.tColumna3)">
          <div v-for="(subitem, subindex) in item.columna3" :key="subindex">
            <y-subitem :subitem="subitem"></y-subitem>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ySubitem from "@/components/informes/Subitem.vue";

export default {
  props: {
    vista: {
      type: Array
    }
  },
  methods: {
    color(c) {
      const size = {
        "col-md-12": "is-12",
        "col-md-4": "is-4",
        "col-md-7": "is-7",
        "col-md-5": "is-5",
        "col-md-6": "is-6"
      };
      return size[c];
    }
  },
  components: {
    ySubitem
  }
};
</script>


// WEBPACK FOOTER //
// src/components/informes/Vista.vue